export default __webpack_public_path__ + "static/media/fortune-life-white.27abb5e7.png";